import { NgModule } from '@angular/core';
//import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { HttpClient } from '@angular/common/http';
//import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
//import { TranslateHttpLoader } from '@ngx-translate/http-loader';
//import { SelectLookupService } from './services/select-lookup.service';
//import { SignalrOverlayService } from './services/signalr-overlay.service';
//import { SignalrService } from './services/signalr.service';
//import { CurrencyConverterService } from './services/currency-converter.service';
//import { EntityService } from './services/entity.service';
//import { SearchDataAggregateService } from './services/search-data-aggregate.service';

//// Telerik Imports
//import { ButtonsModule } from '@progress/kendo-angular-buttons';
//import { GridModule, ExcelModule, GridComponent } from '@progress/kendo-angular-grid';
//import { IconsModule } from '@progress/kendo-angular-icons';
//import { LayoutModule } from '@progress/kendo-angular-layout';
//import { LabelModule } from '@progress/kendo-angular-label';
//import { TextBoxModule, TextAreaModule, CheckBoxModule, NumericTextBoxModule } from '@progress/kendo-angular-inputs';
//import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
//import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
//import { PopupModule } from '@progress/kendo-angular-popup';
//import { ContextMenuModule } from '@progress/kendo-angular-menu';
//import { ToolBarModule } from '@progress/kendo-angular-toolbar';
//import { AppBarModule } from '@progress/kendo-angular-navigation';
//import { BreadCrumbModule } from '@progress/kendo-angular-navigation';
//import { DialogModule, WindowModule } from '@progress/kendo-angular-dialog';
//import { IndicatorsModule } from '@progress/kendo-angular-indicators';
//import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
//import { ChartsModule } from '@progress/kendo-angular-charts';
//import { NotificationModule } from "@progress/kendo-angular-notification";
//import { TooltipModule } from '@progress/kendo-angular-tooltip';
//import { EditorModule } from '@progress/kendo-angular-editor';
//import { UploadsModule } from "@progress/kendo-angular-upload";
//import { ScrollViewModule } from '@progress/kendo-angular-scrollview';

//import 'hammerjs';

//// FontAwesome
//import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

//// Components
//import { SelectFieldComponent } from '../shared/components/select-field/select-field.component';
//import { AppBarComponent } from './components/app-bar/app-bar.component';
//import { FooterBarComponent } from '../shared/components/footer-bar/footer-bar.component';
//import { CustomToolBarComponent } from '../shared/components/custom-tool-bar/custom-tool-bar.component';
//import { SearchGridComponent } from '../shared/components/grid/search-grid.component';
//import { GridContextMenuComponent } from '../shared/components/grid-context-menu/grid-context-menu.component';
//import { ToolbarComponent } from '../shared/components/tool-bar/tool-bar.component';
//import { SearchComponent } from '../shared/components/search/search.component';
//import { DetailComponent } from '../shared/components/detail/detail.component';
//import { TabComponent } from '../shared/components/tab/tab.component';
//import { FormControlComponent } from './components/form-control/form-control.component';
//import { FormRowComponent } from './components/form-row/form-row.component';
//import { GridDetailComponent } from './components/grid-detail/grid-detail.component';
//import { FeedbackMessagesComponent } from './components/feedback-messages/feedback-messages.component';
//import { UrlSettingComponent } from './components/url-setting/url-setting.component';
//import { SignalrOverlayComponent } from './components/signalr-overlay/signalr-overlay.component';
//import { MoneyFieldComponent } from './components/money-field/money-field.component';
//import { GridHeaderComponent } from './components/grid-header/grid-header.component';
//import { DialogComponent } from './components/dialog/dialog.component';
//import { UploadComponent } from './components/upload/upload.component';

//// Pipes
//import { GridAggregatePipe } from './pipes/grid-aggregate.pipe';
//import { GridCellFormatPipe } from './pipes/grid-cell-format.pipe';
//import { LocalTimeConverterPipe } from './pipes/local-time-converter.pipe';
//import { SafePipe } from './pipes/safe.pipe';
//import { CommonModule } from '@angular/common';

//// Directives
//import { GridHeaderDirective } from './directives/grid-header.directive';
//import { NotificationComponent } from './components/notification/notification.component';
//import { UrlFieldComponent } from './components/url-field/url-field.component';
//import { SearchPostDataService } from './services/search-post-data.service';
//import { GridDataBindingDirective } from './directives/grid-data-binding.directive';
//import { RemoteSearchService } from '../core/services/remote-search.service ';
//import { WizardComponent } from './components/wizard/wizard/wizard.component';
//import { StepComponent } from './components/wizard/step/step.component';
//import { HeaderComponent } from './components/header/header.component';
//import { SideCartComponent } from './components/side-cart/side-cart.component';
//import { DetailLayoutComponent } from './components/detail-layout/detail-layout.component';
//import { UploadImageComponent } from './components/upload-image/upload-image.component';
//import { GridKendoCardComponent } from './components/grid-kendo-card/grid-kendo-card.component';
//import { KendoCardFormControlComponent } from './components/kendo-card-form-control/kendo-card-form-control.component';
//import { KendoCardFormRowComponent } from './components/kendo-card-form-row/kendo-card-form-row.component';


// This is where the Navbar, Footer, and other common shared components will live

@NgModule({
  imports: [
    //TranslateModule.forChild({
    //  loader: {
    //    provide: TranslateLoader,
    //    useFactory: HttpLoaderFactory,
    //    deps: [HttpClient]
    //  }
    //}),
    //FormsModule,
    //CommonModule,
    //ReactiveFormsModule,
    //DropDownsModule,
    //ButtonsModule,
    //GridModule,
    //ExcelModule,
    //IconsModule,
    //LayoutModule,
    //LabelModule,
    //TextBoxModule,
    //TextAreaModule,
    //CheckBoxModule,
    //DatePickerModule,
    //PopupModule,
    //ContextMenuModule,
    //ToolBarModule,
    //AppBarModule,
    //FontAwesomeModule,
    //DialogModule,
    //WindowModule,
    //IndicatorsModule,
    //ProgressBarModule,
    //TooltipModule,
    //EditorModule,
    //UploadsModule,
    //ScrollViewModule,
    //ChartsModule,
    //BreadCrumbModule,
    //NumericTextBoxModule,
    //NotificationModule
  ],
  exports: [
    //SelectFieldComponent,
    //AppBarComponent,
    //FooterBarComponent,
    //SearchComponent,
    //DetailComponent,
    //DetailLayoutComponent,
    //FeedbackMessagesComponent,
    //HeaderComponent,
    //LocalTimeConverterPipe,
    //MoneyFieldComponent,
    //TabComponent,
    //SideCartComponent,
    //ToolbarComponent,
    //GridHeaderDirective,
    //GridDataBindingDirective,
    //UrlFieldComponent,
    //GridContextMenuComponent,
    //WizardComponent,
    //StepComponent,
    //GridDetailComponent,
    //SearchGridComponent,
    //DialogComponent,
    //UploadComponent,
    //UploadImageComponent,
    //GridKendoCardComponent
  ],
  declarations: [
    //SelectFieldComponent,
    //AppBarComponent,
    //FooterBarComponent,
    //CustomToolBarComponent,
    //SearchGridComponent,
    //GridContextMenuComponent,
    //ToolbarComponent,
    //SearchComponent,
    //DetailComponent,
    //DetailLayoutComponent,
    //TabComponent,
    //FormControlComponent,
    //FormRowComponent,
    //GridDetailComponent,
    //FeedbackMessagesComponent,
    //UrlSettingComponent,
    //SignalrOverlayComponent,
    //GridAggregatePipe,
    //GridCellFormatPipe,
    //LocalTimeConverterPipe,
    //HeaderComponent,
    //MoneyFieldComponent,
    //GridHeaderDirective,
    //GridDataBindingDirective,
    //GridHeaderComponent,
    //NotificationComponent,
    //SafePipe,
    //UrlFieldComponent,
    //WizardComponent,
    //StepComponent,
    //SideCartComponent,
    //DialogComponent,
    //UploadComponent,
    //DetailLayoutComponent,
    //UploadImageComponent,
    //GridKendoCardComponent,
    //KendoCardFormControlComponent,
    //KendoCardFormRowComponent
  ],
  providers: [
    //SelectLookupService,
    //SignalrOverlayService,
    //SignalrService,
    //CurrencyConverterService,
    //EntityService,
    //SearchPostDataService,
    //SearchDataAggregateService,
    //RemoteSearchService
  ]
})
export class SharedModule { }

//export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
//  return new TranslateHttpLoader(http);
//}
